(function() {
  'use strict';

  function onlyUnique(value, index, array) {
    return array.indexOf(value) === index;
  }

  function addOption(select, label, value) {
    let opt = document.createElement('option');
    opt.value = value;
    opt.innerHTML = label;
    select.appendChild(opt);
  }

  function ProjectList(container) {
    this.container = container;
    this.form = container.querySelector('[data-type="lns-project-filter-form"]');
    this.list = container.querySelector('[data-type="project-list"]');
    // check which container is visible
    this.filterContainer = this.form.querySelector('[data-type="filter-wrap"]');
    if (this.filterContainer === null) {
      console.log('No filter container found.');
      return;
    }
    this.items = this.list.querySelectorAll('[data-type="project-item"]');
    this.items = Array.prototype.slice.call(this.items, 0);
    this.formBubbles = container.querySelectorAll('[data-type="lns-project-filter-bubbles"]');

    this.store = window.location.pathname;

    this.firstLoad = true;
    this.step = 1;
    this.count = 0;
    // null means the initial request should use the configured latest year.
    this.year = null;
    this.randomSort = true;
    this.mainCategory = '';
    this.subCategory = '';
    this.distinction = '';
    this.search = '';
    this.page = '';
    this.isRestoringFilterState = false;
    this.itemsPerPage = this.list.getAttribute('data-items-per-page') || 48;
    this.detailPid = this.list.getAttribute('data-detail-page') || 0;
    this.latestYear = this.list.getAttribute('data-latest-year') || 9999;
    this.hash = this.list.getAttribute('data-hash') || '';

    this.filterYear = this.filterContainer.querySelector('[data-type="lns-project-filter-year"]');
    this.filterMainCategory = this.filterContainer.querySelector('[data-type="lns-project-filter-maincategory"]');
    this.filterSubCategory = this.filterContainer.querySelector('[data-type="lns-project-filter-subcategory"]');
    this.filterDistinction = this.filterContainer.querySelector('[data-type="lns-project-filter-distinction"]');
    this.filterSearch = this.filterContainer.querySelector('[data-type="data-search"]');
    this.filterReset = this.filterContainer.querySelector('[data-type="lns-project-filter-reset"]');
    this.filterCount = this.filterContainer.querySelector('[data-type="lns-project-filter-count"]');
    this.loadingIndicator = null;

    this.init();
  }

  ProjectList.prototype = {
    ensureLoadingIndicator: function () {
      if (this.loadingIndicator) {
        return;
      }

      this.loadingIndicator = this.container.querySelector('[data-type="lns-project-filter-loading"]');
      if (this.loadingIndicator) {
        return;
      }

      let loadingIndicator = document.createElement('div');
      loadingIndicator.setAttribute('data-type', 'lns-project-filter-loading');
      loadingIndicator.className = 'lns-project-filter-loading';
      loadingIndicator.setAttribute('aria-live', 'polite');
      loadingIndicator.setAttribute('aria-hidden', 'true');
      loadingIndicator.hidden = true;

      let spinner = document.createElement('span');
      spinner.className = 'lns-project-filter-loading-spinner';
      spinner.setAttribute('aria-hidden', 'true');

      let label = document.createElement('span');
      label.className = 'lns-project-filter-loading-label';
      label.textContent = 'Loading...';

      loadingIndicator.appendChild(spinner);
      loadingIndicator.appendChild(label);
      this.list.parentNode.insertBefore(loadingIndicator, this.list);
      this.loadingIndicator = loadingIndicator;
    },

    setLoadingState: function (isLoading) {
      this.ensureLoadingIndicator();
      if (!this.loadingIndicator) {
        return;
      }

      this.loadingIndicator.hidden = !isLoading;
      this.loadingIndicator.setAttribute('aria-hidden', isLoading ? 'false' : 'true');
      this.list.setAttribute('aria-busy', isLoading ? 'true' : 'false');
      this.container.classList.toggle('is-filter-loading', isLoading);
      this.loadingIndicator.classList.toggle('hidden', isLoading ? false : true);
    },

    getSessionStorageValues: function () {
      let configJSON = sessionStorage.getItem('projectfilter-' + this.store);
      let config = JSON.parse(configJSON);
      if (config) {
        this.isRestoringFilterState = true;
        // console.log('Loaded filter configuration from sessionStorage:', config);
        if (this.filterYear) {
          if (config.year === undefined || config.year === null) {
            this.year = null;
          } else {
            this.year = config.year;
            this.filterYear.value = config.year;
          }
        }
        if (this.filterMainCategory) {
          this.mainCategory = config.mainCategory;
          this.filterMainCategory.value = config.mainCategory;
          this.setMainCategory(config.mainCategory);
        }
        if (this.filterSubCategory) {
          this.subCategory = config.subCategory;
          this.filterSubCategory.value = config.subCategory;
        }
        if (this.filterDistinction) {
          if (config.distinction === 'all') {
            config.distinction = '';
          }
          this.distinction = config.distinction;
          this.filterDistinction.value = config.distinction;
        }
        if (this.filterSearch) {
          this.search = config.search;
          this.filterSearch.value = config.search;
        }
        if (config.page) {
          this.page = config.page;
        }
        this.isRestoringFilterState = false;
      }
    },

    setSessionStorageValues: function () {
      let config = {
        'year': this.year,
        'mainCategory': this.mainCategory,
        'subCategory': this.subCategory,
        'distinction': this.distinction,
        'search': this.search,
        'page': this.page
      };
      let configJSON = JSON.stringify(config);
      sessionStorage.setItem('projectfilter-' + this.store, configJSON);
    },

    resetToFirstPage: function () {
      if (this.isRestoringFilterState) {
        return;
      }

      this.page = '1';

      if (window.location.hash === '') {
        return;
      }

      let url = new URL(window.location.href);
      url.hash = '';
      window.history.replaceState({}, document.title, url.toString());
    },

    getLatestYear: function () {
      // Returns the value of the most recent year option (first non-empty option).
      if (!this.filterYear) {
        return '';
      }
      for (let i = 0; i < this.filterYear.options.length; i++) {
        if (this.filterYear.options[i].value !== '') {
          return this.filterYear.options[i].value;
        }
      }
      return '';
    },

    reset: function (el) {
      if (el) {
        switch (el.id) {
          case 'year':
            this.year = '';
            this.filterYear.value = this.year;
            break;
          case 'maincategory':
            this.mainCategory = '';
            break;
          case 'subcategory':
            this.subCategory = '';
            break;
          case 'distinction':
            this.distinction = '';
            break;
          case 'searchfield':
            this.search = '';
            break;
          case 'page':
            // get the anchor #page-1 from the current url and remove it, then remove the anchor from the browser url without reloading the page
              let url = new URL(window.location.href);
              url.hash = '';
              window.history.replaceState({}, document.title, url.toString());
              this.page = '1';
            break;
        }
      } else {
        // Full reset: always switch to the most recent year.
        let url = new URL(window.location.href);
        url.hash = '';
        window.history.replaceState({}, document.title, url.toString());
        this.year = this.getLatestYear() || null;
        this.filterYear.value = this.year;
        this.mainCategory = '';
        this.subCategory = '';
        this.distinction = '';
        this.search = '';
        this.page = '1';
      }
      if (el && el.id !== 'page') {
        this.resetToFirstPage();
      }
      this.setSessionStorageValues();
      this.getSessionStorageValues();
      this.filter();
    },

    setYear: function (value) {
      this.year = value;
      this.filterYear.value = this.year;
      this.resetToFirstPage();
      this.filter();
      this.setSessionStorageValues();
    },

    setMainCategory: function (value) {
      if (value === '' && this.mainCategory === '') {
        // mainCategory is empty and did not change: Do not change options of subcategories
        return;
      }
      this.mainCategory = value;
      this.resetToFirstPage();

      if (this.filterSubCategory) {
        this.updateSelectValues();
        this.subCategory = '';
        this.filterSubCategory.value = '';
      }

      this.filter();
      this.setSessionStorageValues();
    },

    setSubCategory: function (value) {
      // check if the chosen subCategory value is still valid with the given mainCategory
      // iterate through all subCategory options and check if the value is still available
      if (value !== '' && !this.hasSubCategoryValue(value)) {
        this.subCategory = '';
        this.filterSubCategory.value = '';
      } else {
        this.subCategory = value;
      }
      this.resetToFirstPage();
      this.filter();
      this.setSessionStorageValues();
    },

    setDistinction: function (value) {
      if (value === 'all') {
        value = '';
      }
      this.distinction = value;
      this.resetToFirstPage();
      this.filter();
      this.setSessionStorageValues();
    },

    setSearch: function (value) {
      this.search = value;
      this.resetToFirstPage();
      this.filter();
      this.setSessionStorageValues();
    },

    getPageFromHash: function () {
      let hash = window.location.hash || '';
      let matches = hash.match(/^#(?:page|seite)-(\d+)$/);

      if (!matches) {
        return null;
      }

      return matches[1];
    },

    applyPageFromHash: function () {
      let page = this.getPageFromHash() || '1';

      if (this.page === page) {
        return;
      }

      this.setPage(page);
    },

    updateHashForPage: function (value) {
      let page = String(value || '1');
      let nextHash = page === '1' ? '' : '#page-' + page;

      if (window.location.hash === nextHash) {
        return false;
      }

      window.location.hash = nextHash;
      return true;
    },

    setPage: function (value) {
      this.page = value;
      this.filter();
      this.setSessionStorageValues();
    },

    filter: function () {
      // console.log('Filtering with parameters:', {
      //   year: this.year,
      //   mainCategory: this.mainCategory,
      //   subCategory: this.subCategory,
      //   distinction: this.distinction,
      //   search: this.search,
      //   page: this.page
      // });

      this.removeFormBubbles();
      let count = 0;

      // build ajax call url with filter parameters
      let url = this.list.getAttribute('data-filter-route');
      if (!url) {
        console.error('No data-route attribute found on the list element.');
        return;
      }
      let award= this.list.getAttribute('data-award');
      let layout = this.list.getAttribute('data-layout');
      // console.log('Base URL for fetching filtered items:', url);
      url = new URL(url);
      url.searchParams.set('tx_lnscelumarticles_articlelist[action]', 'filter');
      url.searchParams.set('tx_lnscelumarticles_articlelist[award]', award);
      url.searchParams.set('tx_lnscelumarticles_articlelist[detailPid]', this.detailPid)
      if (this.year === null) {
        url.searchParams.delete('tx_lnscelumarticles_articlelist[year]');
      } else {
        url.searchParams.set('tx_lnscelumarticles_articlelist[year]', this.year);
      }
      url.searchParams.set('tx_lnscelumarticles_articlelist[latestYear]', this.latestYear);
      url.searchParams.set('tx_lnscelumarticles_articlelist[hash]', this.hash);
      url.searchParams.set('tx_lnscelumarticles_articlelist[mainCategory]', this.mainCategory);
      url.searchParams.set('tx_lnscelumarticles_articlelist[subCategory]', this.subCategory);
      url.searchParams.set('tx_lnscelumarticles_articlelist[distinction]', this.distinction);
      url.searchParams.set('tx_lnscelumarticles_articlelist[query]', this.search);
      url.searchParams.set('tx_lnscelumarticles_articlelist[itemsPerPage]', this.itemsPerPage);
      url.searchParams.set('tx_lnscelumarticles_articlelist[page]', this.page);
      url.searchParams.set('tx_lnscelumarticles_articlelist[layout]', layout);
      // console.log('Fetching filtered items from URL:', url.href);
      this.setLoadingState(true);
       // fetch filtered items via ajax and update the list
       window.fetch(url)
        .then(async (response) => {
          const responseBody = await response.text();
          const contentType = (response.headers.get('content-type') || '').toLowerCase();

          if (!response.ok) {
            throw new Error('Filter request failed with status ' + response.status + '. Body preview: ' + responseBody.slice(0, 3000));
          }

          if (!contentType.includes('application/json')) {
            throw new Error('Expected JSON response but got content-type "' + contentType + '". Body preview: ' + responseBody.slice(0, 3000));
          }

          try {
            return JSON.parse(responseBody);
          } catch (parseError) {
            throw new Error('Invalid JSON in filter response. Body preview: ' + responseBody.slice(0, 30000));
          }
        })
        .then(result => {
          if (!result || typeof result !== 'object') {
            console.warn('Invalid filter result payload:', result);
            return;
          }
          if (!this.firstLoad){
            // jump to beginning of the container but 200px above to account for a possible fixed header
            this.scrollToElementWithHeaderOffset(this.filterContainer);
          }
          // console.log('Received filter result:', result);
          // update list and pagination markup from rendered HTML fragment
          this.updateListMarkup(result.html);
          // update select options based on the new backend result arrays
          this.updateSelectValues(result);
          this.removeFormBubbles();
          this.updateFormBubbles();
          this.firstLoad = false;
        })
        .catch(error => {
          console.error('Error fetching filtered items:', error);
        })
        .finally(() => {
          this.setLoadingState(false);
        });
      if (this.filterCount) {
        this.filterCount.innerHTML = this.items.length !== count ? count + ' / ' : '';
      }
      // this.updateFormBubbles();
    },

    getBubbleLabel: function (element, value) {
      const elementId = element.id;
      const elementLabel = this.form.querySelector('label[for="' + elementId + '"]');
      if (null === elementLabel) {
        return null;
      }
      let bubbleLabel = elementLabel.textContent.trim() + ': ';
      return bubbleLabel + value;
    },

    isSelectField: function (element) {
      return 'select-one' === element.type;
    },

    createBubbleElement: function (label) {
      const bubbleElement = document.createElement('button');
      const bubbleLabelNode = document.createTextNode(label);
      bubbleElement.setAttribute('type', 'button');
      bubbleElement.setAttribute('tabindex', '0');
      bubbleElement.classList.add('lns-filter-bubble');
      bubbleElement.appendChild(bubbleLabelNode);
      const bubbleClose = document.createElement('div');
      bubbleClose.classList.add('lns-filter-bubble-close');
      bubbleElement.appendChild(bubbleClose);
      return bubbleElement;
    },

    createBubble: function (element, value) {
      const bubbleLabel = value;
      if (null === bubbleLabel) {
        return;
      }
      for (let i = 0; i < this.formBubbles.length; i++) {
        const bubble = this.createBubbleElement(bubbleLabel);
        this.formBubbles[i].appendChild(bubble);
        bubble.addEventListener(
          'click',
          () => this.reset(element),
          false
        );
        bubble.addEventListener(
          'keydown',
          (event) => {
            if (event.key === ' ') {
              event.preventDefault();
              event.target.click();
            }
          },
          false
        );
      }
    },

    removeFormBubbles: function () {
      for (let i = 0; i < this.formBubbles.length; i++) {
        while (this.formBubbles[i].firstChild) {
          this.formBubbles[i].removeChild(this.formBubbles[i].firstChild);
        }
      }
    },

    addFormBubble: function (element) {
      const elementValue = element.value;
      if (true === this.isSelectField(element)) {
        if ('' !== elementValue) {
          const selectedLabel = element.options[element.selectedIndex].text;
          this.createBubble(element, selectedLabel);
        }
        return;
      }
      if ('' !== elementValue) {
        this.createBubble(element, ' ' + elementValue);
      }
    },

    updateFormBubbles: function () {
      const formElements = this.form.querySelectorAll('input, select');
      formElements.forEach(element => {
        this.addFormBubble(element);
      });
    },

    updateSelectValues: function (result) {
      // console.log('Updating select options with result data:', result);
      if (!result) {
        return;
      }

      if (Array.isArray(result.years)) {
        this.replaceSelectOptions(this.filterYear, result.years);
      }
      if (Array.isArray(result.mainCategories)) {
        this.replaceSelectOptions(this.filterMainCategory, result.mainCategories);
      }
      if (Array.isArray(result.subCategories)) {
        this.replaceSelectOptions(this.filterSubCategory, result.subCategories);
      }
      if (Array.isArray(result.awardings)) {
        this.replaceSelectOptions(this.filterDistinction, result.awardings);
      }

      if (this.filterYear && Object.prototype.hasOwnProperty.call(result, 'year') && result.year !== null) {
        if (result.year === undefined || result.year === '' || result.year === 0) {
          // make sure to always have a valid value in the filterYear
          this.year = '';
          this.filterYear.value = '';
        } else {
          this.year = String(result.year);
          this.filterYear.value = this.year;
        }
      }

      if (this.filterMainCategory && Object.prototype.hasOwnProperty.call(result, 'mainCategory')) {
        this.mainCategory = result.mainCategory || '';
        this.filterMainCategory.value = this.mainCategory;
      }

      if (this.filterSubCategory && Object.prototype.hasOwnProperty.call(result, 'subCategory')) {
        this.subCategory = result.subCategory || '';
        this.filterSubCategory.value = this.subCategory;
      }

      if (this.filterDistinction && Object.prototype.hasOwnProperty.call(result, 'awarding')) {
        this.distinction = result.awarding || '';
        if (this.distinction === 'all') {
          this.distinction = '';
        }
        this.filterDistinction.value = this.distinction;
      }
    },

    replaceSelectOptions: function (select, values) {
      if (!select || !Array.isArray(values)) {
        return;
      }

      for (let i = select.length - 1; i > 0; i--) {
        select.remove(i);
      }

      values
        .filter(n => n !== null && n !== undefined && n !== '')
        .filter(onlyUnique)
        .forEach((value) => addOption(select, value, value));
    },

    updateListMarkup: function (listItemsHTML) {
      // console.log('Updating list markup with new HTML fragment.', { listItemsHTML });
      if (!listItemsHTML || !this.list) {
        return;
      }
      let result = new DOMParser().parseFromString(listItemsHTML, 'text/html');
      let nextList = result.querySelector('[data-type="project-list"]');
      if (nextList) {
        if (this.randomSort) {
          let awardCards = nextList.querySelector('[data-type="project-items"]');
          let targetContainer = awardCards || nextList;
          let itemsArray = Array.from(targetContainer.querySelectorAll('[data-type="project-item"]'));
          // console.log('Shuffling items for random sort.', { itemsArray });

          for (let i = itemsArray.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [itemsArray[i], itemsArray[j]] = [itemsArray[j], itemsArray[i]];
          }
          targetContainer.innerHTML = '';
          itemsArray.forEach(item => targetContainer.appendChild(item));
        }
        this.list.innerHTML = nextList.innerHTML;
      }

      this.items = this.list.querySelectorAll('[data-type="project-item"]');
      this.items = Array.prototype.slice.call(this.items, 0);
    },

    hasSubCategoryValue: function (value) {
      const opts = this.filterSubCategory.options;
      return Array.from(opts).some(opt => opt.value === value);
    },

    scrollToElementWithHeaderOffset: function (element) {
      if (!element) {
        return;
      }
      const header = document.querySelector('header');
      const headerOffset = (header ? header.offsetHeight : 0) + 34; // 20px extra offset for better visibility
      const elementTop = element.getBoundingClientRect().top + window.pageYOffset;
      const targetTop = Math.max(elementTop - headerOffset, 0);

      window.scrollTo({
        top: targetTop,
        behavior: 'smooth'
      });
    },

    init: function() {
      // console.log('init: Initializing project list filter.');
      const self = this;
      this.ensureLoadingIndicator();
      if (this.filterReset) {
        this.filterReset.addEventListener('click', function() {
          self.reset();
        });
      }
      // this.updateFormBubbles();
      if (this.filterYear) {
        this.filterYear.addEventListener('change', function () {
          self.setYear(this.options[this.selectedIndex].value);
        });
      }
      if (this.filterMainCategory) {
        this.filterMainCategory.addEventListener('change', function () {
          self.setMainCategory(this.options[this.selectedIndex].value);
        });
      }
      if (this.filterSubCategory) {
        this.filterSubCategory.addEventListener('change', function () {
          self.setSubCategory(this.options[this.selectedIndex].value);
        });
      }
      if (this.filterDistinction) {
        this.filterDistinction.addEventListener('change', function () {
          self.setDistinction(this.options[this.selectedIndex].value);
        });
      }
      if (this.filterSearch) {
        let timeout;
        const searchWait = function (e) {
          clearTimeout(timeout);
          let search = e.target.value;
          timeout = setTimeout(function () {
            self.setSearch(search);
          }, 2000);
        };
        this.filterSearch.addEventListener('keyup', searchWait);
        this.filterSearch.addEventListener('input', searchWait);
      }
      this.container.addEventListener('click', function (e) {
        const pageLink = e.target.closest('[data-type="lns-project-filter-pagination"] a[data-page]');
        if (!pageLink) {
          return;
        }
        e.preventDefault();
        const page = pageLink.getAttribute('data-page') || '1';
        if (!self.updateHashForPage(page)) {
          self.setPage(page);
        }
      });
      this.getSessionStorageValues();
      let pageFromHash = this.getPageFromHash();
      if (pageFromHash !== null) {
        this.page = pageFromHash;
      }
      window.addEventListener('hashchange', function () {
        self.applyPageFromHash();
      });
      this.filter();
    },
  };

  document.addEventListener('DOMContentLoaded', function () {
    /** @type {NodeListOf<Element>} */
    let containers = document.querySelectorAll('[data-type="lns-project-filter-wrap"]');
    for (let i = 0; i < containers.length; i++) {
      new ProjectList(containers[i]);
    }
  });
})();
